var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-grid__header",style:({ width: `${_vm.gridWidth}px` })},[_vm._l((_vm.columnsBuffer),function(slot,index){return [(slot.item)?_c('div',{key:`h-${index}`,staticClass:"timeline-grid__header-column",style:({
        left: `${slot.position.left || 0}px`,
        width: `${_vm.columnWidth}px`,
      })},[_c('div',[_vm._v(_vm._s(_vm.formatDate(slot.item.date)))])]):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"timeline-grid__header-column"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }